import React from 'react';
import {observer} from 'mobx-react';
import store from '../../../../s';
import PaymentCodes from '../../../payment/paymentCodes';
import {ICheckoutStep, ISpecialDiscountCodeType} from '../../../../i';

interface IPromoProps {
    editingPromo: boolean;
    onTogglePromo: () => void;
    reloadPayment: () => void;
    reloadPaymentFailure: () => void;
}

const Promo = observer(({editingPromo, onTogglePromo, reloadPayment, reloadPaymentFailure}: IPromoProps) => {
    return (
        <>
            {!editingPromo && (
                <div
                    className="cs-flex"
                    style={{paddingTop: 12}}
                >
                    <div></div>
                    <div>
                        {!store.checkout.code_promo_applied && (
                            <button
                                className="link text-btn b"
                                onClick={onTogglePromo}
                                type="button"
                                aria-label="Promo Code"
                            >
                                + Promo Code{' '}
                                <span style={{paddingLeft: 4}}>
                                    <i
                                        className="fas fa-tags"
                                        aria-hidden={true}
                                    />
                                </span>
                            </button>
                        )}
                        {store.checkout.code_promo_applied && (
                            <button
                                className="link text-btn"
                                onClick={onTogglePromo}
                                type="button"
                                aria-label="Promo Code"
                            >
                                Promo Code ({store.checkout.code_promo.value}){' '}
                                <span style={{paddingLeft: 4}}>
                                    <i
                                        className="fas fa-tags"
                                        aria-hidden={true}
                                    />
                                </span>
                            </button>
                        )}

                        {store.checkout.code_promo_applied &&
                            store.checkout.code_promo_type === ISpecialDiscountCodeType.freeshipping &&
                            store.checkout.code_promo_shipping_text != undefined &&
                            store.checkout.code_promo_shipping_text.length > 0 &&
                            store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production > 0 &&
                            store.checkout.cstep <= ICheckoutStep.shipping && <div style={{fontWeight: 'normal'}}>* Shipping discount ({store.checkout.code_promo_shipping_text}) will be applied after shipping information is entered.</div>}
                    </div>
                </div>
            )}

            {editingPromo && (
                <div
                    className="cs-flex"
                    style={{paddingTop: 12}}
                >
                    <div>
                        <PaymentCodes
                            reloadPayment={reloadPayment}
                            reloadPaymentFailure={reloadPaymentFailure}
                            promoOnly={true}
                        />
                    </div>
                </div>
            )}
        </>
    );
});

export default Promo;
